module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_ChapHead"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }), _vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_BodyText"
  }, [_vm._v("Our special thanks go to Kevin J. Anderson, Rebecca Moesta, Peter J. Wacks, Jessyca Hogue, Keith J. Olexa, Quincy Allen, and Diane Jones of WordFire Press, and our agent John Silbersack.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63530244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0005.vue
// module id = 72
// module chunks = 0